import axios from 'axios'

import { SHUFFLE_SAMPLE_LIMIT_MAX } from '../../shared/config/constants'
import { appendCollectionFilterParams } from '../../shared/filters/collectionFilterQuery'
import type { CollectionFilters } from '../../shared/types/filters'
import type { ShuffleSampleItem } from '../../shared/types/shuffle'

/** Records a started shuffle; background sample preloads do not count. */
export async function recordShuffleStart(): Promise<void> {
	await axios.post('/api/shuffle/start')
}

export type ShuffleFacetsResponse = {
	count: number
	facets: {
		genres: { value: string; count: number }[]
		styles: { value: string; count: number }[]
		yearRange: { min: number | null; max: number | null }
	}
}

export type ShuffleFacetQuery = Partial<CollectionFilters> & {
	includeHidden?: boolean
}

/**
 * Fetches result counts and facet values for the current shuffle filter selection.
 */
export async function getShuffleFacets(
	query: ShuffleFacetQuery,
): Promise<ShuffleFacetsResponse> {
	const params = new URLSearchParams()
	appendCollectionFilterParams(params, query)

	const res = await axios.get(`/api/shuffle?${params.toString()}`)
	return res.data as ShuffleFacetsResponse
}

type ShuffleSampleResponse = {
	sample: ShuffleSampleItem[]
}

/**
 * Fetches a random sample of matching releases for shuffle previews and animation.
 */
export async function getShuffleSample(
	query: ShuffleFacetQuery,
	opts?: { limit?: number; signal?: AbortSignal },
): Promise<ShuffleSampleResponse> {
	const params = new URLSearchParams()
	appendCollectionFilterParams(params, query)
	if (opts?.limit)
		params.set(
			'limit',
			String(Math.min(opts.limit, SHUFFLE_SAMPLE_LIMIT_MAX)),
		)

	const res = await axios.get(`/api/shuffle/sample?${params.toString()}`, {
		signal: opts?.signal,
	})
	return res.data as ShuffleSampleResponse
}
